'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Func = /** @class */ (function () {
    function Func() {
    }
    Func.sum = function (numbers) {
        var sum = 0;
        numbers.forEach(function (num) {
            sum += num;
        });
        return sum;
    };
    Func.getExtention = function (filename) {
        var types = filename.split('.');
        return types[types.length - 1].toLowerCase();
    };
    Func.numberFormat = function (number) {
        return number.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,');
    };
    Func.unitFormat = function (number, unit) {
        if (unit === void 0) { unit = "B"; }
        var str = number;
        if (number > 1 * 1000 * 1000 * 1000) {
            str = Func.numberFormat((number / 1000 / 1000 / 1000).toFixed(2)) + "G";
        }
        else if (number > 1 * 1000 * 1000) {
            str = Func.numberFormat((number / 1000 / 1000).toFixed(2)) + "M";
        }
        else if (number > 1 * 1000) {
            str = Func.numberFormat((number / 1000).toFixed(2)) + "K";
        }
        return str + unit;
    };
    Func.inArray = function (needle, haystack) {
        var result = false;
        Object.keys(haystack).forEach(function (i) {
            if (needle == haystack[Number(i)]) {
                result = true;
            }
        });
        return result;
    };
    Func.dateFormat = function (date, format) {
        if (format === void 0) { format = 'Y-m-d H:i:s'; }
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDay();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var second = date.getSeconds();
        return format.replace('Y', year)
            .replace('m', Func.sprintf(month, 2))
            .replace('d', Func.sprintf(day, 2))
            .replace('n', month)
            .replace('j', day)
            .replace('H', hour)
            .replace('i', minutes)
            .replace('s', second);
    };
    /**
     * @param number
     * @param number
     * @return string
     */
    Func.sprintf = function (num, len) {
        if (String(num).length >= len) {
            return String(num);
        }
        else {
            var zeros = len - String(num).length;
            var str = "";
            for (var i = 0; i < zeros; i++) {
                str += "0";
            }
            return str + String(num);
        }
    };
    Func.smoothScroll = function (target, flagAnimation) {
        if (flagAnimation === true) {
            var speed = 500;
            $("html, body").animate({ scrollTop: target }, speed, "swing");
        }
        else {
            var speed = 0;
            $("html, body").animate({ scrollTop: target }, speed, "linear");
        }
        return false;
    };
    Func.number = function (val) {
        val = val.replace(/[^0-9]/g, '');
        if (isNaN(val)) {
            return 0;
        }
        else {
            return Number(val);
        }
    };
    // テキストを分割して配列を取得
    Func.getWords = function (str) {
        var ary = [];
        str = str.replace(/　/g, ' ');
        if (str.indexOf(' ')) {
            ary = str.split(' ');
            ary = ary.filter(function (k) { return k; });
        }
        else if (str) {
            ary = [str];
        }
        return ary;
    };
    // Json データを取得
    Func.getJsonData = function (id) {
        var data = {};
        if ($('#' + id).length > 0) {
            var elem = document.getElementById(id);
            if (elem) {
                data = JSON.parse(elem.textContent);
            }
        }
        return data;
    };
    // 2つの配列から共通要素を取得
    Func.getArraysIntersect = function (ary1, ary2) {
        return ary1.concat(ary2).filter(function (item) { return ary1.includes(item) && ary2.includes(item); });
    };
    // 重複を削除
    Func.getArrayUnique = function (_a) {
        var array = _a.slice(0);
        return array.filter(function (value, index, self) { return self.indexOf(value) === index; });
    };
    // クリップボードにコピー
    Func.copyToClipboard = function (string) {
        // 空div 生成
        var tmp = document.createElement("div");
        // 選択用のタグ生成
        var pre = document.createElement('pre');
        // 親要素のCSSで user-select: none だとコピーできないので書き換える
        pre.style.webkitUserSelect = 'auto';
        pre.style.userSelect = 'auto';
        tmp.appendChild(pre).textContent = string;
        // 要素を画面外へ
        var s = tmp.style;
        s.position = 'fixed';
        s.right = '200%';
        // body に追加
        document.body.appendChild(tmp);
        // 要素を選択
        document.getSelection().selectAllChildren(tmp);
        // クリップボードにコピー
        var result = document.execCommand("copy");
        // 要素削除
        document.body.removeChild(tmp);
        return result;
    };
    return Func;
}());
exports.default = Func;
